import React from 'react';

function RoundCloseIconFill(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={11.5} cy={11.75} r={11} fill='#fff' />
      <line
        x1={15.2636}
        y1={15.7631}
        x2={7.48546}
        y2={7.98492}
        stroke="#5e5e5e"
      />
      <line
        x1={15.5137}
        y1={7.98576}
        x2={7.73554}
        y2={15.7639}
        stroke="#5e5e5e"
      />
    </svg>
  );
}

export default RoundCloseIconFill;